export default function TbSM({data}) {
    let lastReading = data.data;
    let ro = lastReading.ro_ro_inproc;
    switch(lastReading.ro_ro_status) {
        case 26:
            ro = ro + ' (In House Cond)';
            break;
        case 35:
            ro = ro + ' (For Load Out)';
            break;
        default:
    } 
    return (
      <>
        <div className="card card-table mb-4 rounded-1 shadow-sm">
          <div className="card-header py-2">
            <h4 className="my-0">Skim Milk</h4>
          </div>
          <div className="card-body nopadding">
          <table className="table table-sm my-0 tbl">
              <thead>
                <tr>
                  <th scope="col">Silo</th>
                  <th scope="col">Lbs</th>
                  <th scope="col">Temp</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>SM 1</td>
                  <td>{lastReading.sm_sm1_lbs}</td>
                  <td>{lastReading.sm_sm1_temp}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="card-footer">
            <div className="row">
              <div className="col">RO Running: {ro}</div>
            </div>
            <div className="row">
              <div className="col">Cond. Skim Totalizer: {lastReading.cs_tot_lbs} lbs</div>
            </div>
          </div>
        </div>
      </>
    )
}